import React, { FC } from 'react';
import PropertyDisplay from '../../../components/PropertyDisplay/PropertyDisplay';
import LoadingText from '../../../components/Loading/LoadingText';
import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import { formatCurrency } from '../../../utils/currencyUtils';

interface ComponentPricesPropertiesProps {
	compact?: boolean;
	cibPricePerCode?: number | null;
	premiumSkuPricePerCode?: number | null;
	showCIBPrice?: boolean;
	showInvestorRewards?: boolean;
}

const ComponentPricesProperties: FC<ComponentPricesPropertiesProps> = ({
	compact,
	cibPricePerCode,
	premiumSkuPricePerCode,
	showCIBPrice,
	showInvestorRewards,
}) => {
	return (
		<>
			<SectionTitle className="mt-3">Price Per Code</SectionTitle>
			{showInvestorRewards && (
				<PropertyDisplay label="Investor Rewards" compact={compact}>
					{premiumSkuPricePerCode === undefined
						? <LoadingText inline className="m-0" />
						: premiumSkuPricePerCode != null
						? formatCurrency(premiumSkuPricePerCode, 4)
						: <>&mdash;</>}
				</PropertyDisplay>
			)}
			{showCIBPrice && (
				<PropertyDisplay label="Code-in-Box" compact={compact}>
					{cibPricePerCode === undefined
						? <LoadingText inline className="m-0" />
						: cibPricePerCode != null
						? formatCurrency(cibPricePerCode, 4)
						: <>&mdash;</>}
				</PropertyDisplay>
			)}
			<PropertyDisplay label="Premium SKU" compact={compact}>
				{premiumSkuPricePerCode === undefined
					? <LoadingText inline className="m-0" />
					: premiumSkuPricePerCode != null
					? formatCurrency(premiumSkuPricePerCode, 4)
					: <>&mdash;</>}
			</PropertyDisplay>
			<PropertyDisplay label="Code for Resale" compact={compact}>
				{premiumSkuPricePerCode === undefined
					? <LoadingText inline className="m-0" />
					: premiumSkuPricePerCode != null
					? formatCurrency(premiumSkuPricePerCode, 4)
					: <>&mdash;</>}
			</PropertyDisplay>
		</>
	);
};

export default ComponentPricesProperties;
